import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'acris-blog-author-date',
    label: 'acris-blog.blocks.blogAuthorDate.label',
    category: 'acris-blog',
    component: 'sw-cms-block-acris-blog-author-date',
    previewComponent: 'sw-cms-preview-acris-blog-author-date',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: null,
        marginRight: null,
        sizingMode: 'boxed'
    },
    slots: {
        column: {
            type: 'acris-blog-author-date'
        },
    }
});
